var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.961538 0C0.4305 0 0 0.422847 0 0.944444C0 1.46604 0.4305 1.88889 0.961538 1.88889H24.0385C24.5694 1.88889 25 1.46604 25 0.944444C25 0.422847 24.5694 0 24.0385 0H0.961538ZM0 8.5C0 7.9784 0.4305 7.55556 0.961538 7.55556H24.0385C24.5694 7.55556 25 7.9784 25 8.5C25 9.0216 24.5694 9.44444 24.0385 9.44444H0.961538C0.4305 9.44444 0 9.0216 0 8.5ZM0 16.0556C0 15.534 0.4305 15.1111 0.961538 15.1111H24.0385C24.5694 15.1111 25 15.534 25 16.0556C25 16.5771 24.5694 17 24.0385 17H0.961538C0.4305 17 0 16.5771 0 16.0556Z",
    fill: "#607AFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.78e739cbb03ef9afbba159da64da7e5f.svg";
export { ForwardRef as ReactComponent };